import { Injectable, Renderer2, RendererFactory2, Type } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

@Injectable({
    providedIn: 'root',
})
export class SidePanelService {
    height: string;
    rightOffset: string;
    private dialogRef: MatDialogRef<any, any>;
    private resizeListener: () => void;
    private renderer: Renderer2;
    // Set per-open() call via its optional minWidthPx param — 0 preserves the existing 35%/90%-only
    // behaviour for every caller that doesn't pass one. Needed because some designs (e.g. the NEO
    // cash-out flow) are laid out against a fixed pixel width (Figma's 627px frame) rather than a
    // percentage of viewport, so on narrower/laptop-width screens 35% renders narrower than the
    // content needs and causes wrapping. Stored as instance state (like height/rightOffset above)
    // so the resize listener's recalculation keeps honouring it.
    private minWidthPx = 0;

    constructor(public dialog: MatDialog, private rendererFactory: RendererFactory2) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    private calculateModalHeightWidth() {
        const drawerContentElement = document.querySelector('.mat-drawer-content') as HTMLElement;
        const measurement = { height: '0px', rightOffset: '0px', width: '0px' };
        if (drawerContentElement) {
            measurement.height = `${drawerContentElement.offsetHeight}px`;
            const drawerRect = drawerContentElement.getBoundingClientRect();
            measurement.rightOffset = `${window.innerWidth - drawerRect.right}px`;
            // matDialogConfig.width = drawerRect.width > 627 ? `30%` : `${window.innerWidth}px`;
            const percentWidth = window.innerWidth <= 768 ? '90%' : '35%';
            measurement.width = this.minWidthPx > 0 ? `max(${this.minWidthPx}px, ${percentWidth})` : percentWidth;
        }
        return measurement;
    }

    open(component: Type<any>, matDialogConfig: MatDialogConfig = {}, minWidthPx = 0) {
        this.minWidthPx = minWidthPx;
        const measurement = this.calculateModalHeightWidth();
        this.height = measurement.height;
        this.rightOffset = measurement.rightOffset;
        matDialogConfig.width = measurement.width;

        const config: MatDialogConfig = {
            ...matDialogConfig,
            height: this.height,
            position: { right: this.rightOffset, ...matDialogConfig.position },
            panelClass: 'side-panel',
        };

        this.dialogRef = this.dialog.open(component, config);

        this.addResizeListener();

        this.dialogRef.afterClosed().subscribe(() => {
            this.removeResizeListener();
            // this.dialogRef = null;
        });

        return this.dialogRef;
    }

    private addResizeListener() {
        if (!this.resizeListener) {
            this.resizeListener = this.renderer.listen('window', 'resize', () => {
                if (this.dialogRef) {
                    const measurement = this.calculateModalHeightWidth();
                    this.dialogRef.updateSize(measurement.width, measurement.height);
                }
            });
        }
    }

    private removeResizeListener() {
        if (this.resizeListener) {
            this.resizeListener();
            this.resizeListener = () => {};
        }
    }
}
